module.exports = __webpack_public_path__ + "img/logo.dc952332.png";